import React from 'react';
import { EDULAI_BLUE, EDULAI_ORANGE, EDULAI_PURPLE } from '../../styles/styleConsts';
import strenghtIcon from '../../assets/strengths.png';
import weaknessIcon from '../../assets/weaknesses.png';
import translations from '../../translations/i18next';
import { connect } from 'react-redux';
import { isMobileBrowser } from '../../utils/utilsFunctions';
import { Html } from '../Html/Html';

const SkillDescription = ({ style, testId, reportData }) => {
  return (
    <div style={{ ...style }} id={testId}>
      <p style={{ width: '100%', color: EDULAI_PURPLE, fontSize: 16 }}>
        <Html>{reportData?.description}</Html>
      </p>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 8,
            backgroundColor: 'rgba(245, 125, 36, 0.12)',
            padding: 20,
            margin: 20,
            marginLeft: 0,
            width: isMobileBrowser() ? '100%' : '50%'
          }}
        >
          <img src={strenghtIcon} style={{ height: 60, alignSelf: 'center' }} alt="strenght" />
          <h2 style={{ color: EDULAI_ORANGE, textAlign: 'center' }}>{translations.t(`skillsReport.strengths`)}</h2>
          <p style={{ fontSize: 16, color: EDULAI_PURPLE }}>
            <Html>{reportData?.strengths}</Html>
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 8,
            backgroundColor: 'rgba(77, 102, 185, 0.08)',
            padding: 20,
            margin: 20,
            marginRight: 0,
            width: isMobileBrowser() ? '100%' : '50%'
          }}
        >
          <img src={weaknessIcon} style={{ height: 60, textAlign: 'center', alignSelf: 'center' }} alt="weakness" />
          <h2 style={{ color: EDULAI_BLUE, textAlign: 'center' }}>{translations.t(`skillsReport.weaknesses`)}</h2>
          <p style={{ color: EDULAI_PURPLE, fontSize: 16 }}>
            <Html>{reportData?.mediumWeaknesses}</Html>
            <Html>{reportData?.lowWeaknesses}</Html>
          </p>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    lang: state.utils.selectedLanguage
  };
}

export default connect(mapStateToProps)(SkillDescription);
